// Privacy Policy - Arabic version (RTL)

export const privacyContentAR = {
  sections: [
    { id: 'general', title: '1. أحكام عامة' },
    { id: 'data', title: '2. البيانات التي نعالجها' },
    { id: 'purposes', title: '3. الأغراض والأسس القانونية' },
    { id: 'cookies', title: '4. ملفات تعريف الارتباط والتحليلات' },
    { id: 'ai-services', title: '5. خدمات الذكاء الاصطناعي والسحابة' },
    { id: 'transfer', title: '6. نقل وتخزين البيانات' },
    { id: 'rights', title: '7. حقوق أصحاب البيانات' },
    { id: 'security', title: '8. الأمان' },
    { id: 'contacts', title: '9. معلومات الاتصال' }
  ],
  
  general: {
    title: '1. أحكام عامة',
    content: `تصف هذه السياسة كيفية معالجة Polyus Plus OÜ (يشار إليها فيما يلي باسم "الشركة") للبيانات الشخصية وفقًا لللائحة (EU) 2016/679 (GDPR) وقانون حماية البيانات الشخصية الإستوني.

تعمل الشركة كـ:

• **مراقب البيانات** (عند تشغيل الموقع والتسويق)
• **معالج البيانات** (عند تقديم الخدمات للعملاء بموجب العقود وDPA)`
  },
  
  data: {
    title: '2. البيانات التي نعالجها',
    categories: [
      {
        name: 'البيانات الشخصية',
        icon: 'Eye',
        items: ['الاسم والمسمى الوظيفي', 'بيانات الاتصال (البريد الإلكتروني، الهاتف)', 'بيانات النماذج والمراسلات']
      },
      {
        name: 'بيانات الشركة (B2B)',
        icon: 'Database',
        items: ['اسم الشركة', 'رقم التسجيل', 'العنوان القانوني']
      },
      {
        name: 'المعلومات التقنية',
        icon: 'Globe',
        items: ['عنوان IP', 'ملفات تعريف الارتباط والمعرفات', 'بيانات التحليل']
      },
      {
        name: 'مهم',
        icon: 'AlertCircle',
        items: ['نحن لا نجمع بيانات شخصية حساسة (الأصل العرقي، الدين، الصحة)']
      }
    ]
  },
  
  purposes: {
    title: '3. الأغراض والأسس القانونية',
    intro: 'تتم المعالجة لـ:',
    bases: [
      {
        title: 'تنفيذ العقد',
        legal: 'Art. 6(1)(b) GDPR',
        description: 'التواصل، الفوترة، تقديم الخدمة',
        color: 'blue'
      },
      {
        title: 'التسويق',
        legal: 'Art. 6(1)(a) GDPR',
        description: 'بموافقتك (يمكن سحبها في أي وقت)',
        color: 'green'
      },
      {
        title: 'التحليلات وتحسين الموقع',
        legal: 'Art. 6(1)(f) GDPR',
        description: 'المصلحة المشروعة للشركة',
        color: 'cyan'
      },
      {
        title: 'الالتزامات القانونية',
        legal: 'Art. 6(1)(c) GDPR',
        description: 'التشريعات الضريبية والمحاسبية',
        color: 'yellow'
      }
    ]
  },
  
  cookies: {
    title: '4. ملفات تعريف الارتباط والتحليلات',
    intro: 'يستخدم الموقع ملفات تعريف الارتباط وخدمات التحليل لتحسين تجربة المستخدم وفهم كيفية استخدام الزوار لموقعنا.',
    services: [
      { name: 'Google Analytics 4', description: 'تحليل حركة المرور والسلوك' },
      { name: 'Meta Pixel (Facebook)', description: 'الإعلان وإعادة الاستهداف' },
      { name: 'Hotjar', description: 'خرائط حرارية وتحليل UX' }
    ],
    note: 'يمكنك إدارة إعدادات ملفات تعريف الارتباط في متصفحك أو من خلال إعداداتنا.',
    linkText: 'سياسة ملفات تعريف الارتباط'
  },
  
  aiServices: {
    title: '5. خدمات الذكاء الاصطناعي والسحابة',
    intro: 'لأداء الخدمات، تستخدم Polyus Plus OÜ منصات AI وخدمات سحابية حديثة:',
    platforms: [
      'OpenAI (ChatGPT, DALL-E)',
      'Google Cloud AI',
      'Microsoft Azure',
      'Notion, Airtable'
    ],
    transferNote: 'عند نقل البيانات خارج الاتحاد الأوروبي، يتم تطبيق الحماية على شكل **بنود تعاقدية قياسية للاتحاد الأوروبي (SCC)** وآليات أخرى معتمدة من المفوضية الأوروبية.'
  },
  
  transfer: {
    title: '6. نقل وتخزين البيانات',
    intro: 'يمكن نقل البيانات فقط إلى:',
    recipients: [
      {
        title: 'موظفي ومقاولي Polyus Plus OÜ',
        description: 'مع اتفاقيات سرية موقعة'
      },
      {
        title: 'مزودي الاستضافة والسحابة والتحليلات',
        description: 'AWS، Google Cloud، Vercel وغيرها (مع DPA)'
      },
      {
        title: 'الجهات الحكومية',
        description: 'فقط عند الطلبات القانونية (المحكمة، مصلحة الضرائب)'
      }
    ],
    retention: {
      title: 'فترة الاحتفاظ',
      period: 'حتى 5 سنوات',
      note: 'بعد انتهاء العقد، ما لم ينص القانون على خلاف ذلك (مثل التشريعات الضريبية أو المحاسبية - 7 سنوات).'
    }
  },
  
  rights: {
    title: '7. حقوق أصحاب البيانات',
    intro: 'وفقًا لللائحة العامة لحماية البيانات، لديك الحقوق التالية:',
    list: [
      { title: 'حق الوصول', description: 'الحصول على نسخة من بياناتك الشخصية' },
      { title: 'حق التصحيح', description: 'تصحيح البيانات غير الدقيقة' },
      { title: 'حق المحو', description: '"الحق في النسيان" (في ظل ظروف معينة)' },
      { title: 'حق التقييد', description: 'تقييد معالجة بياناتك' },
      { title: 'حق نقل البيانات', description: 'الحصول على البيانات في تنسيق منظم' },
      { title: 'حق الاعتراض', description: 'سحب الموافقة على المعالجة' }
    ],
    exercise: {
      title: 'كيف تمارس حقوقك؟',
      instruction: 'أرسل طلبًا إلى info@polyusplus.com. سنرد خلال 30 يومًا.',
      complaint: 'لديك أيضًا الحق في تقديم شكوى إلى السلطة الإشرافية: **Andmekaitse Inspektsioon** (سلطة حماية البيانات الإستونية) - aki.ee'
    }
  },
  
  security: {
    title: '8. الأمان',
    intro: 'تطبق الشركة تدابير تقنية وتنظيمية حديثة لحماية بياناتك الشخصية من الوصول غير المصرح به أو التسريب أو التغيير أو التدمير.',
    measures: [
      { title: 'التشفير', description: 'SSL/TLS لنقل البيانات', icon: 'Lock' },
      { title: 'مراقبة الوصول', description: 'مصادقة متعددة العوامل', icon: 'Shield' },
      { title: 'خوادم آمنة', description: 'AWS، Google Cloud مع DPA', icon: 'Database' }
    ],
    breach: {
      title: 'إخطار بالانتهاكات',
      text: 'في حالة انتهاك البيانات الشخصية، سنخطر السلطة الإشرافية خلال 72 ساعة ونخطرك شخصيًا إذا كان الانتهاك يشكل خطرًا كبيرًا على حقوقك وحرياتك.'
    }
  },
  
  contacts: {
    title: '9. معلومات الاتصال',
    intro: 'للأسئلة حول معالجة البيانات الشخصية أو لممارسة حقوقك، يرجى الاتصال بنا:',
    company: 'Polyus Plus OÜ',
    regNumber: '14890902',
    address: 'Uuslinna 11, Tallinn 11415, Estonia',
    email: 'info@polyusplus.com'
  },
  
  gdprNotice: 'تتوافق هذه السياسة مع متطلبات اللائحة (EU) 2016/679 (GDPR) وقانون حماية البيانات الشخصية الإستوني. بياناتك محمية على أعلى مستوى أوروبي.'
};
